import { Box, Flex, customStyled, Text } from '@mafc/trolly';

export const ShipmentItemHeader = customStyled(Box)(props => ({
  marginBottom: props.theme.space[3],
}));

export const ShipmentStats = customStyled(Flex)(() => ({
  justifyContent: 'space-between',
}));

export const SoldBy = customStyled(Flex)(({ theme: { fontSizes, colors } }) => ({
  fontSize: fontSizes[1],
  color: colors.Gray100,
}));

export const ShipmentNumber = customStyled(Text.Caption)(props => ({
  color: props.theme.colors.black,
  fontSize: `${props.theme.fontSizes[3]}px`,
  fontWeight: props.theme.fontWeights[6],
}));
